import { Application } from "@hotwired/stimulus"
import { controllers as bridgeControllers } from "@joemasilotti/bridge-components"

const application = Application.start()
application.load(bridgeControllers)

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }
